
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 13v1.5l3.063-2.281A.987.987 0 019.655 12H14c.531 0 1-.438 1-1V2c0-.531-.469-1-1-1H2c-.563 0-1 .469-1 1v9c0 .563.438 1 1 1h3c.531 0 1 .469 1 1zM2 0h12c1.094 0 2 .906 2 2v9c0 1.125-.906 2-2 2H9.656l-3.875 2.906c-.156.125-.343.125-.531.063A.514.514 0 015 15.5V13H2c-1.125 0-2-.875-2-2V2C0 .906.875 0 2 0zm2 7.25a.722.722 0 01-.75-.75.74.74 0 01.75-.75.76.76 0 01.75.75.74.74 0 01-.75.75zm4 0a.722.722 0 01-.75-.75.74.74 0 01.75-.75.76.76 0 01.75.75.74.74 0 01-.75.75zm4.75-.75a.74.74 0 01-.75.75.722.722 0 01-.75-.75.74.74 0 01.75-.75.76.76 0 01.75.75z","fill":"#212121"}})])
          )
        }
      }
    